<!-- 全部订单页 -->
<template>
  <div class="content">
    <!-- 内容区域 -->
    <div class="bodycontent">
      <!-- 操作栏 -->
      <div class="option" v-if="screenValue">
        <p class="lang_width">
          <span>订单编号</span>
          <span>
            <el-input
              type="text"
              placeholder="请输入订单编号"
              v-model="ordersn"
              style="width:360px"
            />
          </span>
        </p>
        <p class="short_width">
          <span>商品名称</span>
          <span>
            <el-input
              type="text"
              placeholder="请输入商品名称"
              v-model="goods_name"
            />
          </span>
        </p>
        <p class="short_width">
          <span>会员昵称</span>
          <span>
            <el-input
              type="text"
              placeholder="请输入会员昵称"
              v-model="nickname"
            />
          </span>
        </p>
        <p class="short_width">
          <span>订单类型</span>
          <span>
            <el-select v-model="order_type" placeholder="请选择">
              <el-option label="普通订单" value="1"></el-option>
            </el-select>
          </span>
        </p>
      <!-- </div>
      <div class="option" v-if="screenValue"> -->
        <p class="lang_width">
          <!-- 时间日期选择器 -->
          <span>创建时间</span>
          <span>
            <el-date-picker
              v-model="dateValue"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="setQueryTime()"
              style="width:360px"
            >
            </el-date-picker>
          </span>
        </p>
        <p class="short_width">
          <span>配送方式</span>
          <span>
            <el-select v-model="ship_type" placeholder="请选择">
              <el-option label="全部" value=""></el-option>
              <el-option label="快递发货" value="1"></el-option>
              <el-option label="门店自提" value="2"></el-option>
              <el-option label="不需要物流" value="3"></el-option>
            </el-select>
          </span>
        </p>
        <p class="short_width">
          <span>维权状态</span>
          <span>
            <el-select v-model="safeGuard" placeholder="请选择">
            </el-select>
          </span>
        </p>
        <p class="short_width">
          <span>支付方式</span>
          <span>
            <el-select v-model="payment_code" placeholder="请选择">
              <el-option label="全部" value=""></el-option>
              <el-option label="微信支付" value="wxpay"></el-option>
              <el-option label="支付宝支付" value="alipay"></el-option>
              <el-option label="余额支付" value="balance"></el-option>
            </el-select>
          </span>
        </p>
      </div>
      <div class="option">
        <p>
          <span>条件筛选</span>
          <span>
            <el-switch
              v-model="screenValue"
              active-color="#13ce66"
            >
            </el-switch>
          </span>
        </p>
        <p>
          <el-button type="primary" @click="search()" v-if="screenValue">搜索</el-button>
          <el-button>批量标记</el-button>
          <el-button>订单导出</el-button>
          <el-button @click="batchClose">批量关闭</el-button>
          <el-button @click="batchDelete">批量删除</el-button>
        </p>
      </div>
      <!-- 表单数据栏 -->
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        height="string"
        show-header
        style="width: 100%;border: 1px solid #f1f1f1"
        current-row-key
        @selection-change="handleSelectionChange"
        v-loading="tableLoading"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column label="商品信息" width="460">
          <template slot-scope="scope">
            <p class="intable_row1">
              <span>订单编号：{{ scope.row.ordersn }}</span>
              <span>下单时间：{{ scope.row.create_time }}</span>
            </p>
            <p class="intable_row1">
              <span>订单来源：{{ scope.row.show_source }}</span>
              <span
                class="iconfont iconqizi_icon"
                v-if="scope.row.tag_color != null"
                :style="scope.row.tag_style"
              ></span>
            </p>
            <p
              class="intable_row2"
              v-for="item in scope.row.goods"
              :key="item.id"
            >
              <span style="width:50px;height:50px;">
                <img
                  :src="item.image_url"
                  alt=""
                  style="width:100%;height:100%;"
                />
              </span>
              <span>
                <p>{{ item.name }}</p>
                <p>数量：{{ item.nums }}</p>
                <p>单价：¥{{ item.price }}</p>
                <p>商品编码：{{ item.sn }}</p>
              </span>
            </p>
          </template>
        </el-table-column>
        <el-table-column label="实收款" width="120">
          <template slot-scope="scope">
            <p class="intable_row1"></p>
            <p class="intable_row2">
              <span>
                {{ scope.row.pay_amount }}
              </span>
            </p>
          </template>
        </el-table-column>
        <el-table-column
          prop="messageClient"
          label="客户信息"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <p class="intable_row1"></p>
            <p class="intable_row2">
              <span>{{ scope.row.user.username }}</span>
            </p>
          </template>
        </el-table-column>
        <el-table-column label="配送及支付方式">
          <template slot-scope="scope">
            <p class="intable_row1">
              <el-button size="mini" icon="el-icon-document" @click="signButton(scope.row,1)" v-if="scope.row.tag_content">查看备注</el-button>
              <el-button icon="el-icon-message" size="mini" @click="signButton(scope.row,0)">备注</el-button>
            </p>
            <p class="intable_row2">
              <span class="shipments">
                <p class="shipments_item">
                  {{ scope.row.show_ship_type }}
                </p>
                <el-button
                  size="mini"
                  type="primary"
                  plain
                  @click="sendGoodsButton(scope.row)"
                  v-if="scope.row.text_status == 2"
                  >发货</el-button
                >
              </span>
            </p>
          </template>
        </el-table-column>
        <el-table-column label="订单状态">
          <template slot-scope="scope">
            <p class="intable_row1" v-if="scope.row.text_status == 1">
              <el-button
                size="mini"
                icon="el-icon-edit"
                @click="editOrder(scope.row.ordersn)"
                >订单修改</el-button
              >
              <el-button
                icon="el-icon-circle-close-outline"
                size="mini"
                @click="cancelOrderButton(scope.row.ordersn)"
                >关闭订单</el-button
              >
            </p>
            <p class="intable_row2">
              <span class="shipments">
                <p class="shipments_item">
                  {{ scope.row.show_text_status }}
                </p>
                <el-button
                  size="mini"
                  type="primary"
                  @click="detailsItem(scope.row.ordersn)"
                  >订单详情</el-button
                >
              </span>
            </p>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="Otherpage">
        <!-- <div class="changePage">
          <div @click="upPage" class="btnColor">
            <span>上一页</span>
          </div>
          <div>
            <span>{{ page }}</span>
          </div>
          <div @click="downPage" class="btnColor">
            <span>下一页</span>
          </div>
        </div> -->
        <!-- 组件分页 -->
        <el-pagination
          layout="prev, pager, next, total, jumper"
          :current-page="page"
          :total="total"
          :page-size="10"
          @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
    <!-- 修改备注的内容  -->
    <Sign
      :show_sign_dialog="dialog_remark"
      :formData="signForm"
      @close="closeSignDialog"
    ></Sign>
    <!-- 关闭订单的弹框内容 -->
    <CancelOrder
      :showDialog="dialog_close_order"
      :OrderSn="editOrderSn"
      @closeDialog="closeDialog"
    ></CancelOrder>
    <!-- 修改订单的弹窗内容 -->
    <el-dialog title="修改订单" :visible.sync="dialog_amend_order" width="60%">
      <TableProductDetails
        :OrderSn="editOrderSn"
        @changePrice="changePrice"
        @changeFreight="changeFreight"
      ></TableProductDetails>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog_amend_order = false">取 消</el-button>
        <el-button type="primary" @click="saveChange()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 发货弹窗 -->
    <SendGoods
      :showDialog="order_deliver_goods"
      :formData="sendForm"
      @close="closeSendDialog"
    ></SendGoods>
  </div>
</template>
<script>
import TableProductDetails from "@Components/public/table_product_details";
import CancelOrder from "./closeOrder";
import Sign from "./editTag";
import SendGoods from "./sendGoods";
import { OrderList, OrderDetail, EditPrice, DeleteOrder } from "@/api/order";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  components: {
    TableProductDetails,
    CancelOrder,
    SendGoods,
    Sign
  },
  data() {
    return {
      screenValue: true, //显示筛选条件
      dateValue: [],
      tableData: [], // 多选
      multipleSelection: [],
      dialog_remark: false, // 备注
      dialog_close_order: false, // 订单关闭
      signForm: {}, //备注token和ordersn
      dialog_amend_order: false, // 订单修改
      order_deliver_goods: false, //发货
      sendForm: {}, //发货表单
      freightNum: 0, // freightNum 运费加减
      discountsNum: 0, // 优惠加减
      formLabelWidth: "120px",
      page: 1, //当前页码
      status: 1, //订单状态0=所有订单 1=待付款 2=待发货 3=待收货 4=待评价 5=已评价 6=已完成 7=已取消
      ordersn: "", //筛选 订单编号
      start_time: "", //筛选 开始时间
      end_time: "", //筛选 结束时间
      editOrderSn: "", //修改、删除时选择的订单编号
      newColor: "", //选择标记颜色
      price_array: [], //商品价格变动数组 键为订单商品id值为变动价格组合
      freight_update: "0", //运费价格变动
      allordersn: "", //选中的订单编号
      goods_name:"", //筛选 商品名称
      nickname:"", //筛选 会员昵称
      order_type:"", //筛选 订单类型
      ship_type:"", //筛选 配送方式
      safeGuard:"", //筛选 维权状态
      payment_code:"", //筛选 支付方式
      tableLoading: false, //表格加载loading
      total: 0, //列表总数
    };
  },
  mounted() {
    this.getOrderList();
    this.$store.commit("SET_STATE", "2");
  },
  methods: {
    //查询时间
    setQueryTime() {
      console.log(this.dateValue);
      this.start_time = this.dateValue[0];
      this.end_time = this.dateValue[1];
    },
    //发货按钮
    sendGoodsButton(row) {
      console.log(row);
      OrderDetail({
        token: this.token,
        app_id: this.app_id,
        ordersn: row.ordersn
      }).then(res => {
        this.sendForm = {
          ordersn: row.ordersn,
          create_time: row.create_time
        };
        if (row.ship_type == 1) {
          this.sendForm.ship_type = 1;
          this.sendForm.address =
            res.data.address.area + " " + res.data.address.address;
        } else {
          this.sendForm.ship_type = 3;
          this.sendForm.address = "";
        }
        this.order_deliver_goods = true;
      });
    },
    //关闭发货弹窗
    closeSendDialog(rel) {
      this.order_deliver_goods = false;
      if (rel == 1) {
        this.getOrderList();
      }
    },
    // 标记弹窗
    signButton(row,i) {
      this.signForm = {
        token: this.token,
        ordersn: row.ordersn,
        app_id: this.app_id,
        tag_content: row.tag_content,
        readonly:i,
        color:'color:'+row.tag_color
      };
      this.dialog_remark = true;
    },
    // 关闭备注弹窗
    closeSignDialog(rel) {
      console.log("rel", rel);
      this.dialog_remark = false;
      if (rel == 1) {
        this.getOrderList();
      }
    },
    // 子组件价格变动
    changePrice(val) {
      val.forEach((item, index) => {
        var jsonData = {};
        jsonData[item.id] = item.price;
        console.log(jsonData);
        this.price_array[index] = JSON.parse(JSON.stringify(jsonData));
      });
      console.log(this.price_array);
    },
    //运费价格变动
    changeFreight(val){
      this.freight_update = val;
    },
    // 保存价格修改
    saveChange() {
      var data = {
        token: this.token,
        ordersn: this.editOrderSn,
        app_id: this.app_id,
        order_goods_update: this.price_array,
        freight_update: this.freight_update
      };
      EditPrice(data).then(res => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: res.msg
          });
          this.dialog_amend_order = false;
        }else{
          this.$message({
            type: "error",
            message: res.msg
          })
        }
      });
    },
    // 订单列表
    getOrderList() {
      this.tableLoading = true;
      var data = {
        token: this.token,
        app_id: this.app_id,
        page: this.page,
        status: this.status,
      };
      if(this.ordersn){
        data.ordersn = this.ordersn
      }
      if(this.start_time){
        data.start_time = this.start_time
      }
      if(this.end_time){
        data.end_time = this.end_time
      }
      if(this.goods_name){
        data.goods_name = this.goods_name
      }
      if(this.nickname){
        data.nickname = this.nickname
      }
      if(this.order_type){
        data.order_type = this.order_type
      }
      if(this.ship_type){
        data.ship_type = this.ship_type
      }
      if(this.payment_code){
        data.payment_code = this.payment_code
      }
      OrderList(data).then(res => {
        this.total = res.total;
        this.tableData = res.data;
        this.tableData.forEach(item => {
          if (item.tag_color != null) {
            item.tag_style = "color:" + item.tag_color;
          }
          item.show_source =
            item.source == 1
              ? "PC页面"
              : item.source == 2
              ? "H5页面"
              : "微信小程序";
          item.show_ship_type =
            item.ship_type == 1
              ? "快递发货"
              : item.ship_type == 2
              ? "门店自提"
              : "不需要物流";
          if (item.pay_status == 1) {
            item.show_pay_status = "未付款";
          } else if (item.pay_status == 2) {
            item.show_pay_status = "已付款";
          } else if (item.pay_status == 3) {
            item.show_pay_status = "部分付款";
          } else if (item.pay_status == 4) {
            item.show_pay_status = "部分退款";
          } else if (item.pay_status == 5) {
            item.show_pay_status = "已退款";
          }
          if (item.ship_status == 1) {
            item.show_ship_status = "未发货";
          } else if (item.ship_status == 2) {
            item.show_ship_status = "部分发货";
          } else if (item.ship_status == 3) {
            item.show_ship_status = "已发货";
          } else if (item.ship_status == 4) {
            item.show_ship_status = "部分退货";
          } else if (item.ship_status == 5) {
            item.show_ship_status = "已退货";
          }
          if (item.text_status == 1) {
            item.show_text_status = "待付款";
          } else if (item.text_status == 2) {
            item.show_text_status = "待发货";
          } else if (item.text_status == 3) {
            item.show_text_status = "待收货";
          } else if (item.text_status == 4) {
            item.show_text_status = "待评价";
          } else if (item.text_status == 5) {
            item.show_text_status = "已评价";
          } else if (item.text_status == 6) {
            item.show_text_status = "已完成";
          } else if (item.text_status == 7) {
            item.show_text_status = "已取消";
          }
        });
        this.tableLoading = false;
      });
    },
    editOrder(sn) {
      this.editOrderSn = sn;
      this.dialog_amend_order = true;
    },
    cancelOrderButton(sn) {
      this.editOrderSn = sn;
      this.dialog_close_order = true;
    },
    closeDialog(rel) {
      console.log(rel);
      this.dialog_close_order = false;
      if (rel == 1) {
        this.getOrderList();
      }
    },
    handleCurrentChange(p){
      this.page = p;
      this.getOrderList()
    },
    upPage() {
      // 上一页
      this.page--;
      if (this.page == 0) {
        this.page = 1;
        this.getOrderList();
      } else {
        this.getOrderList();
      }
    },
    downPage() {
      // 下
      if (this.tableData.length == 10) {
        this.page++;
        console.log(this.page);
        this.getOrderList();
        console.log(this.tableData.length);
        if (this.tableData.length == 0) {
          this.$message("没有更多了");
          this.page--;
        }
      }
    },
    // 表单全选
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.allordersn = "";
      this.multipleSelection.forEach(item => {
        this.allordersn += item.ordersn + ",";
      });
      console.log(this.allordersn);
    },
    //批量关闭订单
    batchClose() {
      if (this.multipleSelection.length == 0) {
        this.$message({
          type: "error",
          message: "请选择订单"
        });
      } else {
        this.editOrderSn = this.allordersn;
        this.dialog_close_order = true;
      }
    },
    //批量删除订单
    batchDelete() {
      var data = {
        token: this.token,
        app_id: this.app_id,
        ordersn: this.allordersn
      };
      DeleteOrder(data).then(res => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: res.msg
          });
          this.getOrderList();
        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      });
    },
    //查看订单详情
    detailsItem(sn) {
      this.$router.push({
        path: "orderDetails",
        query: { ordersn: sn }
      });
      console.log(sn);
    },
    search() {
      this.page = 1;
      this.getOrderList();
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit("SET_STATE", "1");
    next();
  }
};
</script>
<style>
.el-table .cell {
  padding: 0 !important;
}
</style>
<style lang="scss" scoped>
.content {
  padding: 10px 55px 20px 0;
  height: calc(100vh - 102px);
  .bodycontent {
    position: relative;
    padding: 0px 27px 0;
    font-size: 14px;
    height: 100%;
    border: 1px solid #f1f1f1;
    box-shadow: 0 0 3px #f1f1f1;
    display: flex;
    flex-direction: column;
    .option {
      // height: 60px;
      line-height: 60px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .lang_width{
        width:440px;
      }
      .short_width{
        width: 280px;
      }
      p {
        height: 60px;
        span {
          margin-right: 10px;
          .el-input{
            width: 200px;
          }
          .el-select{
            width: 200px;
          }
        }
      }
    }
    // table
    .el-table {
      box-shadow: 0 0 3px #f1f1f1;
      flex: 1;
      padding-left: 20px;
      .el-table__row {
        padding-left: 10px;
        border: 1px solid red !important;
        font-size: 100px;
      }
      // table里面的子行
      .intable_row1 {
        height: 20px;
        span {
          margin-right: 20px;
        }
      }
      .intable_row2 {
        height: 80px;
        margin-top: 10px;
        display: flex;
        align-items: center;
        p {
          font-size: 12px;
          height: 16px;
          margin: 0 0 5px 10px;
        }
        .shipments {
          .shipments_item {
            margin-bottom: 10px;
          }
        }
      }
    }
    
    //分页
    .Otherpage {
      height: 34px;
      width: 200px;
      .changePage {
        height: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        div {
          height: 100%;
          width: 30%;
          text-align: center;
          line-height: 34px;
        }
        .btnColor {
          background: #b0b5bb30;
        }
      }
    }
  }
}
</style>
